import React from 'react';
import { Link } from "react-router-dom";
import { detectMobile } from '../../_helpers.js';
import './Modal.scss';

const Modal = (props) => 
    <div class="Modal">
        <div>
            <div>
                
                { props.gif && 
                    <div>
                        <img src={ `/assets/img/gifs/${props.gif}.gif` } alt={ `${props.gif}` } /> 
                        <div class="Modal--message">
                            <div class="Modal--grid">
                                <input
                                    autofocus="true"
                                    maxlength="30" 
                                    type="text" 
                                    defaultValue={ "Sorry, custom messages for VIP's only!" } 
                                    disabled="true"
                                />
                                <button onClick={ props.handleShowVIP }>VIP</button>
                            </div>
                        </div> 
                        { detectMobile() &&
                            <p><span>save_alt</span> tap and hold for options to save</p>
                        }
                        { !detectMobile() &&
                            <p><span>save_alt</span> right-click and choose an option to save</p>
                        }
                    </div>
                }
                { props.children }
                <button onClick={ props.handleClose }>Close</button>
            </div>
        </div>
    </div>

export default Modal;